export default __webpack_public_path__ + "static/media/DisapprovalIcon.fe3ec82e.svg";